var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionStatementFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25510_105275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2864 8.03819L19.1553 16.3674C19.2367 16.4715 19.2807 16.5985 19.2809 16.7297C19.2815 17.0464 19.0299 17.3052 18.7153 17.3161L18.7049 17.3182L18.6882 17.3162L3.32364 17.3433C3.10489 17.3437 2.90676 17.2232 2.80642 17.0296C2.704 16.836 2.71817 16.6048 2.84286 16.4254L6.67477 10.8915C6.77452 10.7497 6.93061 10.6577 7.1035 10.6428C7.27431 10.628 7.44108 10.686 7.56421 10.8045L9.1937 12.1704L12.1176 8.00067L12.116 7.10275L8.43061 7.10925C8.10769 7.10982 7.84473 6.84778 7.84416 6.52487L7.83964 3.96237C7.83907 3.63945 8.10111 3.37649 8.42403 3.37592L12.6949 3.36839C13.0157 3.36783 13.2786 3.62986 13.2792 3.95278L13.2864 8.03819Z",
    fill: "#8E97A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25510_105275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(2.65088 2.03198) rotate(-0.101015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionStatementFill);
export default __webpack_public_path__ + "static/media/mission-statement-fill.aa638e1b2cf2671340e9c5cc7b645e22.svg";
export { ForwardRef as ReactComponent };